import * as React from 'react';

import { PropertyPolicies } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

const PoliciesWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <RefTarget name="Policies">
      <SimpleLazyLoadWrapper>
        <PropertyPolicies inputs={inputs} />
      </SimpleLazyLoadWrapper>
    </RefTarget>
  </UitkSpacing>
);

export const SharedUiPoliciesWrapper = withSharedUiPropertyDetails(PoliciesWrapper);
SharedUiPoliciesWrapper.displayName = 'SharedUiPoliciesWrapper';
